import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FRZ_89 } from "@/lib/programs/fezMarrakech89";

export default function FezMarrakech89Page() {
  return <ProgramTemplate program={PROGRAM_FRZ_89} variant="frz" showJourneyChronology />;
}
